<template>
    <div class="container">
    <div class="container" v-show="isVisible()">
        <div class="card">

            <div class="card-header"><h1 class="text-center">Input one time intake code</h1></div>
            <div class="card-body">
                <form @submit.prevent="submit">
                    <div class="form-group">
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Code</span>
                            </div>
                            <input class="form-control" type="text" v-model="code" required />
                        </div>
                        <br>
                        <div v-show="invalidCode" class="alert alert-danger" style="text-align: center" role="alert">
                            The code you entered was invalid. 
                        </div>
                        <p style="text-align: center">If you do not have a one time code, please generate one from the staff interface.</p>
                        <button type="submit" class="btn btn-primary btn-block">Use code</button>            
                    </div>
                </form>
            </div>

        </div>

    </div>
    </div>

</template>

<script>
import $ from 'jquery'

export default {
  name: 'Code',
  data: function() {
    return {
        "code": "",
        "invalidCode": false
    };
  },
  methods: {
    isVisible: function() {
      return this.$parent.currentQuestion === "code";
    },
    submit: function() {

        let url;
        if (this.$parent.$data.dev === true) {
            // eslint-disable-next-line
            console.warn("Intake Form development mode is on");
            url = "http://localhost:8080/intake";
        } else {
            url = `../../../intake`;
        }
        url+="?code="+this.$data.code;

        let _this = this;
        $.get(url, function(data){
            if (Boolean(data) === false) {
                _this.$data.invalidCode = true;
            } else {
                _this.$parent.code = _this.$data.code;
                _this.$parent.currentQuestion = "veteranRelationship"; 
            }
        });
    }
    
  },
}
</script>